import React, { useState } from 'react';
import { Image, Modal, ScrollView, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { allStyles } from './FormStyles';
import { translate } from './FormUtils';
import SelectModal from './SelectModal';
import TitleLabel from './TitleLabel';

const styles = StyleSheet.create(allStyles);

export default function FieldSelectModal(props) {
    const [visible, setVisible] = useState(false)

    const temp = props.getItemsByName(props.name);
    const items = Array.isArray(temp) ? temp : [];
    const message = typeof temp === 'string' ? temp : '';

    let selectedItem = {
        label: '',
        value: '',
    };

    if (items) {
        const found = items.find((item) => {
            if (item.value === props.value) {
                return true;
            }
            return false;
        });
        if (found) {
            selectedItem = found;
        }
    }
    
    return (
        <View style={[styles.fieldContainer, props.containerStyle]}>
            <TitleLabel {...props}/>
            <TouchableOpacity disabled={props.editable === false} style={[styles.selectContainer, (typeof selectedItem.label === 'string' && selectedItem.label.length > 0) ? styles.filledBox : {}, props.editable === false && styles.disabledBox]} onPress={() => { setVisible(true); }}>
                <Text style={{flexGrow:1}}>{selectedItem.label}</Text>
                <Image style={styles.selectIcon} resizeMode={'contain'} source={require('../../assets/arrow_down.png')}/>
            </TouchableOpacity>
            <SelectModal
                visible={visible}
                title={`${translate(['FORM', 'ENTER'])}${props.title}`}
                message={message}
                items={items}
                selectedItem={{value: props.value}}
                onSelect={(item) => {
                    setVisible(false);
                    props.onChange({
                        name: props.name,
                        value: item.value,
                    });
                }}
                onBlankPress={() => {
                    setVisible(false);
                }}
            />
        </View>
    )
}